import { render, staticRenderFns } from "./AddBrand.vue?vue&type=template&id=2fbc178c&scoped=true&"
import script from "./AddBrand.vue?vue&type=script&lang=js&"
export * from "./AddBrand.vue?vue&type=script&lang=js&"
import style0 from "./AddBrand.vue?vue&type=style&index=0&id=2fbc178c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbc178c",
  null
  
)

export default component.exports